import { AfterViewInit, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { DocumentService } from '../../providers/document.service';
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { NgIf } from "@angular/common";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'rename-dialog',
  providers: [],
  styleUrls: ['./rename-dialog.scss'],
  standalone: true,
  imports: [
    MatIcon,
    MatDialogModule,
    MatLabel,
    MatFormFieldModule,
    TranslateModule,
    ReactiveFormsModule,
    NgIf,
    MatInput,
    MatButton
  ],
  templateUrl: './rename-dialog.html'
})
export class RenameDocumentDialogComponent implements AfterViewInit {

    public readonly NAME_MAX_LENGTH: number = 150;
    public form: FormControl = new FormControl('', [
        Validators.required
    ]);

    constructor(
        public dialog: MatDialogRef<RenameDocumentDialogComponent>,
        private _translater: TranslateService,
        private _documentService: DocumentService,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.form.setValue(_data.name);
    }

    public ngAfterViewInit() {}

    public onConfirmClicked(): void {
        if (this.form.valid) {
            this._documentService.rename(
                this._data.organization,
                this._data.athlete,
                this._data.documentId,
                this.form.value
            ).subscribe(document => {
                this.dialog.close(document);
            })
        } else {
            this.form.markAllAsTouched();
        }
    }

}
